export const sm = 360;
export const md = 768;
export const lg = 1080;
export const xl = 1440;